import LinkSessionReducer from "../reducers/LinkSessionReducer";
import BaseAction from "./BaseAction";

class LinkSessionAction extends BaseAction {
  toggleLinkSession = (row) => {
    const { linkedSessionData } = this.data();
    const isSelected = linkedSessionData.find(
      (x) => x.sessionId === row.sessionId,
    );
    if (isSelected) {
      const updatedData = linkedSessionData.filter(
        (x) => x.sessionId !== row.sessionId,
      );
      this.dispatch({
        linkedSessionData: updatedData,
      });
    } else {
      this.dispatch({
        linkedSessionData: [...linkedSessionData, row],
      });
    }
  };

  onOptionChange = (newData) => {
    this.dispatch({ linkedSessionData: newData });
  };

  removeSelectedSessions = (sessionToBeDeleted) => {
    const { linkedSessionData } = this.data();
    const updatedData = linkedSessionData.filter(
      (x) => !sessionToBeDeleted.includes(x),
    );
    this.dispatch({ linkedSessionData: updatedData });
    return updatedData;
  };
}

const action = new LinkSessionAction(LinkSessionReducer);

export default action;
